import React from 'react';
import BaseField, { BaseFieldProps } from '../../Inputs/BaseField/BaseField';
import TermItemAsyncSelect from './TermItemAsyncSelect';
import { SelectValue } from '../../../../../Components/Base/Select/Select';

interface Props extends BaseFieldProps {
	onChange?: (value: SelectValue) => void;
	termType: string;
}

const TermItemAsyncSelectField: React.FC<Props> = props => {
	return (
		<BaseField {...props}>
			<TermItemAsyncSelect
				onChange={props.onChange}
				termType={props.termType}
			/>
		</BaseField>
	);
};

export default TermItemAsyncSelectField;
